// extracted by mini-css-extract-plugin
export default {"additionalChargesList":"AdditionalChargesList_additionalChargesList__f1s4S"};